import { defineStore } from 'pinia';

export interface GeoParams {
  city_id?: number;
  city_name: string;
  country_id?: number;
  country_name?: string;
}

export interface GeoParamsRequired {
  city_id: number;
  city_name: string;
  country_id: number;
  country_name: string;
}

export const useSeoStore = defineStore('seo', {
  state: (): { geo: GeoParams } => ({
    geo: { city_name: '' },
  }),
  getters: {
    geoRequired: (state): GeoParamsRequired => ({
      city_id: state.geo.city_id ?? 0,
      city_name: state.geo.city_name,
      country_id: state.geo.country_id ?? 0,
      country_name: state.geo.country_name ?? '',
    }),
  },
});
